import { render, staticRenderFns } from "./LoungePage.vue?vue&type=template&id=0c472f2e&scoped=true&"
import script from "./LoungePage.vue?vue&type=script&lang=js&"
export * from "./LoungePage.vue?vue&type=script&lang=js&"
import style0 from "./LoungePage.vue?vue&type=style&index=0&id=0c472f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c472f2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
